(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-verification-modal"] && !Shopify.designMode) return;
  try {
    class AgeVerificationDialog extends window.customElements.get('dialog-component').prototype.constructor {
    #resolvePromise = null;

    connectedCallback() {
      super.connectedCallback();

      window.AgeVerification = {
        isVerified: () => document.cookie.includes('age_verified=true'),
      };
    }

    requestVerification() {
      return new Promise((resolve) => {
        this.#resolvePromise = resolve;

        if (window.AgeVerification.isVerified()) {
          resolve(true);
          return;
        }

        this.showDialog();
      });
    }

    handleConfirm() {
      const expires = new Date();
      expires.setDate(expires.getDate() + 30);
      document.cookie = 'age_verified=true; expires=' + expires.toUTCString() + '; path=/; SameSite=Lax; Secure';

      this.closeDialog();

      if (this.#resolvePromise) {
        this.#resolvePromise(true);
        this.#resolvePromise = null;
      }
    }

    handleDeny() {
      this.closeDialog();

      if (this.#resolvePromise) {
        this.#resolvePromise(false);
        this.#resolvePromise = null;
      }

      window.location.href = '/';
    }

    // Override showDialog to prevent escape and backdrop dismissal
    showDialog() {
      const { dialog } = this.refs;

      if (dialog.open) return;

      const scrollY = window.scrollY;
      this._previousScrollY = scrollY;

      requestAnimationFrame(() => {
        document.body.style.width = '100%';
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + scrollY + 'px';

        dialog.showModal();

        // Block escape key
        this.addEventListener('keydown', this.#blockEscape);
      });
    }

    // Override closeDialog to clean up escape listener
    closeDialog = async () => {
      const { dialog } = this.refs;

      if (!dialog.open) return;

      this.removeEventListener('keydown', this.#blockEscape);

      dialog.style.animation = 'none';
      void dialog.offsetWidth;
      dialog.classList.add('dialog-closing');
      dialog.style.animation = '';

      await new Promise((resolve) => {
        dialog.addEventListener('animationend', resolve, { once: true });
        // Fallback timeout
        setTimeout(resolve, 500);
      });

      document.body.style.width = '';
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo({ top: this._previousScrollY || 0, behavior: 'instant' });

      dialog.close();
      dialog.classList.remove('dialog-closing');
    };

    #blockEscape = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
      }
    };
  }

  if (!customElements.get('age-verification-dialog')) {
    customElements.define('age-verification-dialog', AgeVerificationDialog);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu-categories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mega-categories')) {
    customElements.define(
      'mega-categories',
      class MegaCategories extends HTMLElement {
        connectedCallback() {
          this.addEventListener('pointerover', this.onPointerOver);
          this.addEventListener('focusin', this.onFocusIn);
        }

        disconnectedCallback() {
          this.removeEventListener('pointerover', this.onPointerOver);
          this.removeEventListener('focusin', this.onFocusIn);
          clearTimeout(this.timer);
        }

        onPointerOver = (event) => {
          const tab = event.target.closest('[data-mega-tab]');
          if (!tab) return;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.select(tab.dataset.megaTab), 60);
        };

        onFocusIn = (event) => {
          const tab = event.target.closest('[data-mega-tab]');
          if (tab) this.select(tab.dataset.megaTab);
        };

        select(id) {
          for (const tab of this.querySelectorAll('[data-mega-tab]')) {
            tab.classList.toggle('is-active', tab.dataset.megaTab === id);
          }
          for (const panel of this.querySelectorAll('[data-mega-panel]')) {
            panel.hidden = panel.dataset.megaPanel !== id;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
